import { createContext } from "react";

const promoContext = createContext<string>('')

export default promoContext